import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { login as loggUser } from '../../service/auth.service';
import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '../context/auth.context';

const LoginPage: React.FC = () => {
  const [user, setUser] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const { isLoggedIn, setIsLoggedIn, login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    if (!user || !password) {
      setLoading(false);
      setError('Por favor rellenar todos los campos');
    } else {
      setError('');
      const response: any = await loggUser(user, password);
      setLoading(false);
      if (response == null) {
        setError('Usuario o Contraseña Incorrecta');
      } else {
        login(response.data.access_token);
        setIsLoggedIn(true);
      }
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center">
      {isLoggedIn && <Navigate to="/home" replace />}
      <Card style={{ width: '25rem' }}>
        <br />
        <Card.Img
          variant="top"
          src="/rc2.png"
          alt="Descripción"
          style={{ width: '250px', height: 'auto', margin: '0 auto' }}
        />
        <Card.Body>
          <Card.Title className="text-center mb-4">Login</Card.Title>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Correo Electrónico o Rut(12345678-9)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingese e-mail o rut"
                value={user}
                onChange={(e) => setUser(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100 mb-3">
              {loading ? 'Ingresando...' : 'Login'}
            </Button>
          </Form>

          {/* Opciones adicionales */}
          <div className="d-flex justify-content-between">
            {/* <Link to="/registerUser">Crear usuario</Link> */}
            {/*<Link to="/forgot-password">Recuperar contraseña</Link> */}
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default LoginPage;